var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronTop = function SvgChevronTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.705 10.775 9.06 3.945a1.5 1.5 0 0 0-2.12 0l-6.65 6.83a1 1 0 0 0 0 1.43 1 1 0 0 0 1.415 0L8 5.73l6.295 6.5a1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.455"
  })));
};
export default SvgChevronTop;